import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { RowComponent } from '@schoolbelle/common/table';
import { GroupMemberType } from '@schoolbelle/api/group-member';

@Component({
  selector: '[mailmerge-header]',
  templateUrl: './mailmerge-header.component.html',
  styleUrls: ['./mailmerge-header.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class MailmergeHeaderComponent extends RowComponent {
}
